import React, { memo, useContext } from 'react';
import accounting from 'accounting-js';
import { MarketSettings } from './market-settings';
import { CurrencySettings } from './codes';
import { AppContext } from 'src/components/app-context';

export { MarketSettings };

export const formatCurrency = (
  price: PriceType,
  market: string,
  asDiff: boolean,
  code: string,
  omitCode: boolean = false
) => {
  const settings = MarketSettings[market];

  if (!settings || price === undefined || price === null) {
    return null;
  }

  const overrideCode = CurrencySettings[code && code.toLowerCase()];
  const { withDecimals, numberOfDecimals, symbol, format } =
    overrideCode || settings;
  const decimals = numberOfDecimals !== undefined ? numberOfDecimals : 2;
  const options = {
    symbol: omitCode ? '¤' : symbol,
    decimal: settings.decimalSign,
    precision: withDecimals ? decimals : 0,
    thousand: settings.thousandSeparator,
    format,
  };

  let formattedPrice = accounting.formatMoney(price, options);

  if (omitCode) {
    formattedPrice = formattedPrice.replace('¤', '').trim();
  }

  if (asDiff && price > 0) {
    return `+${formattedPrice}`;
  }

  return formattedPrice;
};

type PriceType = string | number | null | undefined;

interface CurrencyProps {
  market?: string;
  price: PriceType;
  asDiff?: boolean;
  code?: string;
  omitCode?: boolean;
}

export const Currency: React.FC<React.PropsWithChildren<CurrencyProps>> = memo(
  props => {
    const {
      price,
      market,
      asDiff = false,
      code = '',
      omitCode = false,
    } = props;
    const context = useContext(AppContext);
    const marketFromParamOrContext = market ?? context.market?.code;

    const curr = formatCurrency(
      price,
      marketFromParamOrContext,
      asDiff,
      code,
      omitCode
    );

    return <>{curr}</>;
  }
);
